import { MDSText, MDSTextVariant, MDSTextWeight } from "@/mds/components/text";
import {
  MDSPlanCard,
  MDSPlanCardSlot,
  MDSPlanCardBackground,
  MDSPlanCardBorder,
  MDSPlanId,
} from "@/mds";
import { MDSBadge, MDSBadgeVariant } from "@/mds/components/badge";
import { MdsIcon, MdsIconKind } from "@/design-system/components/icon";
import {
  freeFeatures,
  proFeatures,
} from "@/pages/settings/components/subscription-management/data";
import { TitleAndBadgeContainer } from "@/pages/settings/components/subscription-management/styled-components";
import { MDSButton, MDSButtonVariant } from "@/mds";
import { CardsRow } from "@/pages/settings/components/subscription-management/subscription.styles";
import styled from "@emotion/styled";

interface Props {
  subscriptionStatusText: string;
  downgradePreposition: string;
  onSubscribe: () => void;
}

export const CanceledPlanManagement: React.FC<Props> = ({
  subscriptionStatusText,
  downgradePreposition,
  onSubscribe,
}) => {
  return (
    <>
      <TitleAndBadgeContainer>
        <MDSText variant={MDSTextVariant.HeaderL}>Pro Plan</MDSText>
        <MDSBadge
          label={`Downgrading ${downgradePreposition}`}
          variant={MDSBadgeVariant.Negative}
          icon={MdsIconKind.Warning}
        />
      </TitleAndBadgeContainer>

      <StyledText>{subscriptionStatusText}</StyledText>

      <CardsRow $columns>
        {/* Free plan  */}
        <MDSPlanCard
          plan={MDSPlanId.Free}
          features={freeFeatures}
          border={MDSPlanCardBorder.Default}
          background={MDSPlanCardBackground.None}
        >
          <MDSText
            variant={MDSTextVariant.HeaderL}
            weight={MDSTextWeight.SemiBold}
            slot={MDSPlanCardSlot.Title}
          >
            Free
          </MDSText>
          <MDSBadge
            label="After downgrade"
            variant={MDSBadgeVariant.Default}
            slot={MDSPlanCardSlot.TitleBadge}
          />

          <div slot={MDSPlanCardSlot.Price}>Free forever</div>
        </MDSPlanCard>

        {/* Pro plan */}
        <MDSPlanCard
          plan={MDSPlanId.Paid}
          features={proFeatures}
          border={MDSPlanCardBorder.Emphasis}
          background={MDSPlanCardBackground.Emphasis}
        >
          <MDSText
            variant={MDSTextVariant.HeaderL}
            weight={MDSTextWeight.SemiBold}
            slot={MDSPlanCardSlot.Title}
          >
            Pro
          </MDSText>
          <MDSBadge
            label="Best for your usage"
            variant={MDSBadgeVariant.MoreEmphasis}
            slot={MDSPlanCardSlot.TitleBadge}
          />
          <div slot={MDSPlanCardSlot.Price}>$12 / month</div>
          <MDSButton
            variant={MDSButtonVariant.Emphasis}
            onClick={onSubscribe}
            slot={MDSPlanCardSlot.Footer}
          >
            <MdsIcon kind={MdsIconKind.StarSolid} />
            Subscribe to Pro
          </MDSButton>
        </MDSPlanCard>
      </CardsRow>
    </>
  );
};

const StyledText = styled(MDSText)(({ theme }) => ({
  margin: `${theme.spacing[5]} 0`,
}));
